import React from 'react'
import * as Cookies from "es-cookie";
import CommonHeader from './CommonHeader';

// Fixed titles for pages identified only by pageType.
const PAGE_TYPE_TITLES = {
    ReferFriend: "Refer A Friend",
    LiveSessions: "NEET Rise Course",
    LiveSessionsCrashCourse: "NEET 2023 Crash Course",
    col_pred_short_list: "Short List Page",
};

// headerBottom types whose title is shown in the header.
const TITLED_TYPES = ["foundation_course", "eamcet_view", "foundation_course_exams", "foundation_classes"];

// Pages that have their own way back and get no Back button.
const NO_BACK_PAGE_TYPES = ["categoryVideos", "quickQuiz", "ReferFriend", "foundation_exams"];

/**
 * Page header used by most student pages. Thin wrapper over CommonHeader
 * that keeps the props pages already pass:
 *   onClick       sidebar toggle
 *   pageType      selects a fixed title / hides Back
 *   headerBottom  { type, title } page title
 *   color, tone   override the header colour (default: a colour of its own per page)
 */
function Navbars({ onClick, pageType, headerBottom, color = "auto", tone = "light" }) {
    const type = headerBottom && headerBottom.type;

    let title = PAGE_TYPE_TITLES[pageType] || null;
    let mobileTitle = true;
    if (!title && TITLED_TYPES.includes(type)) {
        title = headerBottom.title;
    } else if (!title && type === "homePage" && Cookies.get("student_userlevel") == 2) {
        title = headerBottom.title;
        mobileTitle = false;
    }

    let back = !NO_BACK_PAGE_TYPES.includes(pageType);
    if (type === "foundation_course_exams") back = "/student/foundation-course/home";

    return (
        <CommonHeader
            color={color}
            tone={tone}
            onToggleSidebar={onClick}
            back={back}
            title={title}
            mobileTitle={mobileTitle}
        />
    );
}

export default React.memo(Navbars);
